import item from './src/item'
export default {
	...item
}



// WEBPACK FOOTER //
// ./src/lib/common/index.js